import React, { useState, createContext, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import baseUrl from '../api/baseUrl';
import { encrypt } from '../helpers/cryptography';
import isTokenExpired from '../helpers/isTokenExpired';

const URL_LOGIN = `${baseUrl}/auth/authenticate`;
const URL_SIGNUP = `${baseUrl}/auth/register`;

export const UserContext = createContext();

export const UserStorage = ({ children }) => {
  const [data, setData] = useState(null);
  const [login, setLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMonitor, setIsMonitor] = useState(false);
  const [isConsulta, setIsConsulta] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isResp, setIsResp] = useState(false);
  const [isVR, setIsVR] = useState(false);
  const [isVest, setIsVest] = useState(false);
  const [isOuvidoria, setIsOuvidoria] = useState(false);
  const [isOuvidoriaConsulta, setIsOuvidoriaConsulta] = useState(false);
  const [isCipa, setIsCipa] = useState(false);
  const [isCapsAdmin, setIsCapsAdmin] = useState(false);
  const [isCapsSupervisor, setIsCapsSupervisor] = useState(false);
  const [isCapsOperador, setIsCapsOperador] = useState(false);
  const [isCapsConsulta, setIsCapsConsulta] = useState(false);
  const [isCapsDocs, setIsCapsDocs] = useState(false);
  const [isCapsDocsEsp, setIsCapsDocsEsp] = useState(false);
  const [isMdi, setIsMdi] = useState(false);
  const [isMdiAdmin, setIsMdiAdmin] = useState(false);
  const [isErp, setIsErp] = useState(false);
  const [isPesquisa, setIsPesquisa] = useState(false);
  const [isInscricaoAdmin, setIsInscricaoAdmin] = useState(false);
  const [isReducaoDeDanos, setIsReducaoDeDanos] = useState(false);
  const [isReducaoConsulta, setIsReducaoConsulta] = useState(false);
  const [isDocsDas, setIsDocsDas] = useState(false);
  const [isDocsDiti, setIsDocsDiti] = useState(false);
  const [isDocsDtec, setIsDocsDtec] = useState(false);
  const [isDocsDaf, setIsDocsDaf] = useState(false);
  const [isDocsDg, setIsDocsDg] = useState(false);
  const [isCecoAdmin, setIsCecoAdmin] = useState(false);
  const [isCecoOperador, setIsCecoOperador] = useState(false);
  const [isGestor, setIsGestor] = useState(false);
  const [isAtivAdmin, setIsAtivAdmin] = useState(false);
  const [isAtivOperador, setIsAtivOperador] = useState(false);
  const [isAtivConsulta, setIsAtivConsulta] = useState(false);
  const [isLeitos, setIsLeitos] = useState(false);
  // const [theme, setTheme] = useState('light');

  const history = useHistory();

  useEffect(() => {
    const token = window.localStorage.getItem('token');

    if (token) {
      if (isTokenExpired(token)) {
        userLogout();
        
        return;
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const userLogout = useCallback(async () => {
    setData(null);
    setError(null);
    setLoading(false);
    setLogin(false);
    setToken(null);
    setIsAdmin(false);
    setIsMonitor(false);
    setIsConsulta(false);
    setIsUser(false);
    setIsResp(false);
    setIsVR(false);
    setIsVest(false);
    setIsOuvidoria(false);
    setIsOuvidoriaConsulta(false);
    setIsCipa(false);
    setIsCapsAdmin(false);
    setIsCapsSupervisor(false);
    setIsCapsOperador(false);
    setIsCapsConsulta(false);
    setIsCapsDocs(false);
    setIsCapsDocsEsp(false);
    setIsMdi(false);
    setIsMdiAdmin(false);
    setIsErp(false);
    setIsPesquisa(false);
    setIsInscricaoAdmin(false);
    setIsReducaoDeDanos(false);
    setIsReducaoConsulta(false);
    setIsDocsDas(false);
    setIsDocsDiti(false);
    setIsDocsDtec(false);
    setIsDocsDaf(false);
    setIsDocsDg(false);
    setIsCecoAdmin(false);
    setIsCecoOperador(false);
    setIsGestor(false);
    setIsAtivAdmin(false);
    setIsAtivOperador(false);
    setIsAtivConsulta(false);
    setIsLeitos(false);

    window.localStorage.removeItem('login');
    window.localStorage.removeItem('token');

    history.push('/'); 
  }, [history]);

  const authenticate = async data => {
    try {
      setError(null);
      setLoading(true);

      const response = await fetch(URL_LOGIN, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        if (response?.status === 403) {
          setError('Erro no reCAPTCHA');
          throw new Error('Erro no reCAPTCHA');
        }

        setError('E-mail e/ou senha inválidos');
        throw new Error('E-mail e/ou senha inválidos');
      }

      if (response.ok) {
        const data = await response.json();
        const token = data.token;
        localStorage.setItem('login', JSON.stringify(data));
        localStorage.setItem('token', token);
        setToken(token);
        setData(data);
        setLogin(true);
        
        if (data?.user?.roles?.includes(encrypt('ADMIN'))) {
          setIsAdmin(true);
        }

        if (data?.user?.roles?.includes(encrypt('MONITOR'))) {
          setIsMonitor(true);
        }

        if (data?.user?.roles?.includes(encrypt('CONSULTA'))) {
          setIsConsulta(true);
        }

        if (data?.user?.roles?.includes(encrypt('USER'))) {
          setIsUser(true);
        }

        if (data?.user?.roles?.includes(encrypt('RESP'))) {
          setIsResp(true);
        }

        if (data?.user?.roles?.includes(encrypt('VR'))) {
          setIsVR(true);
        }

        if (data?.user?.roles?.includes(encrypt('VESTUARIO'))) {
          setIsVest(true);
        }

        if (data?.user?.roles?.includes(encrypt('OUVIDORIA'))) {
          setIsOuvidoria(true);
        }

        if (data?.user?.roles?.includes(encrypt('OUVIDORIA_CONSULTA'))) {
          setIsOuvidoriaConsulta(true);
        }

        if (data?.user?.roles?.includes(encrypt('CIPA'))) {
          setIsCipa(true);
        }

        if (data?.user?.roles?.includes(encrypt('CAPS_ADMIN'))) {
          setIsCapsAdmin(true);
        }

        if (data?.user?.roles?.includes(encrypt('CAPS_SUPERVISOR'))) {
          setIsCapsSupervisor(true);
        }

        if (data?.user?.roles?.includes(encrypt('CAPS_OPERADOR'))) {
          setIsCapsOperador(true);
        }

        if (data?.user?.roles?.includes(encrypt('CAPS_CONSULTA'))) {
          setIsCapsConsulta(true);
        }

        if (data?.user?.roles?.includes(encrypt('CAPS_DOCS'))) {
          setIsCapsDocs(true);
        }

        if (data?.user?.roles?.includes(encrypt('CAPS_DOCS_ESP'))) {
          setIsCapsDocsEsp(true);
        }

        if (data?.user?.roles?.includes(encrypt('MDI'))) {
          setIsMdi(true);
        }

        if (data?.user?.roles?.includes(encrypt('MDI_ADMIN'))) {
          setIsMdiAdmin(true);
        }

        if (data?.user?.roles?.includes(encrypt('ERP'))) {
          setIsErp(true);
        }

        if (data?.user?.roles?.includes(encrypt('PESQUISA'))) {
          setIsPesquisa(true);
        }

        if (data?.user?.roles?.includes(encrypt('INSCRICAO_ADMIN'))) {
          setIsInscricaoAdmin(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('REDUCAO_DE_DANOS'))) {
          setIsReducaoDeDanos(true);
        }

        if (data?.user?.roles?.includes(encrypt('RD_CONSULTA'))) {
          setIsReducaoConsulta(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('DOCS_DAS'))) {
          setIsDocsDas(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('DOCS_DITI'))) {
          setIsDocsDiti(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('DOCS_DTEC'))) {
          setIsDocsDtec(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('DOCS_DAF'))) {
          setIsDocsDaf(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('DOCS_DG'))) {
          setIsDocsDg(true);
        }

        if (data?.user?.roles?.includes(encrypt('CECO_ADMIN'))) {
          setIsCecoAdmin(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('CECO_OPERADOR'))) {
          setIsCecoOperador(true);
        }

        if (data?.user?.roles?.includes(encrypt('GESTOR'))) {
          setIsGestor(true);
        }

        if (data?.user?.roles?.includes(encrypt('ATIV_ADMIN'))) {
          setIsAtivAdmin(true);
        }

        if (data?.user?.roles?.includes(encrypt('ATIV_OPERADOR'))) {
          setIsAtivOperador(true);
        }

        if (data?.user?.roles?.includes(encrypt('ATIV_CONSULTA'))) {
          setIsAtivConsulta(true);
        }
        
        if (data?.user?.roles?.includes(encrypt('LEITOS'))) {
          setIsLeitos(true);
        }
      }

      history.push('/');

      return data;
    } catch (error) {
      setError(error.message);
      setLogin(false);
      setIsAdmin(false);
      setIsMonitor(false);
      setIsConsulta(false);
      setIsUser(false);
      setIsResp(false);
      setIsVR(false);
      setIsVest(false);
      setIsOuvidoria(false);
      setIsOuvidoriaConsulta(false);
      setIsCipa(false);
      setIsCapsAdmin(false);
      setIsCapsSupervisor(false);
      setIsCapsOperador(false);
      setIsCapsConsulta(false);
      setIsCapsDocs(false);
      setIsCapsDocsEsp(false);
      setIsMdi(false);
      setIsMdiAdmin(false);
      setIsErp(false);
      setIsPesquisa(false);
      setIsInscricaoAdmin(false);
      setIsReducaoDeDanos(false);
      setIsReducaoConsulta(false);
      setIsDocsDas(false);
      setIsDocsDiti(false);
      setIsDocsDtec(false);
      setIsDocsDaf(false);
      setIsDocsDg(false);
      setIsCecoAdmin(false);
      setIsCecoOperador(false);
      setIsGestor(false);
      setIsAtivAdmin(false);
      setIsAtivOperador(false);
      setIsAtivConsulta(false);
      setIsLeitos(false);
    } finally {
      setLoading(false);
    }
  }; 

  const signUp = async ({ token, ...data }) => {
    try {
      setError(null);
      setLoading(true);

      const response = await fetch(URL_SIGNUP, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        setError('E-mail já cadastrado');
      }

      if (response.ok) {
        history.push('/');
      }

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const autoLogin = async () => {
      const login = JSON.parse(localStorage.getItem('login'));
      const token = window.localStorage.getItem('token');

      if (token) {
        if (isTokenExpired(token)) {
          userLogout();
          return;
        }
      }

      if (token) {
        try {
          setError(null);
          setLoading(true);
          setLogin(true);

          if (login?.user?.roles.includes(encrypt('ADMIN'))) {
            setIsAdmin(true);
          }

          if (login?.user?.roles.includes(encrypt('MONITOR'))) {
            setIsMonitor(true);
          }

          if (login?.user?.roles.includes(encrypt('CONSULTA'))) {
            setIsConsulta(true);
          }

          if (login?.user?.roles.includes(encrypt('USER'))) {
            setIsUser(true);
          }

          if (login?.user?.roles.includes(encrypt('RESP'))) {
            setIsResp(true);
          }

          if (login?.user?.roles.includes(encrypt('VR'))) {
            setIsVR(true);
          }

          if (login?.user?.roles.includes(encrypt('VESTUARIO'))) {
            setIsVest(true);
          }

          if (login?.user?.roles.includes(encrypt('OUVIDORIA'))) {
            setIsOuvidoria(true);
          }

          if (login?.user?.roles.includes(encrypt('OUVIDORIA_CONSULTA'))) {
            setIsOuvidoriaConsulta(true);
          }

          if (login?.user?.roles.includes(encrypt('CIPA'))) {
            setIsCipa(true);
          }

          if (login?.user?.roles.includes(encrypt('CAPS_ADMIN'))) {
            setIsCapsAdmin(true);
          }

          if (login?.user?.roles.includes(encrypt('CAPS_SUPERVISOR'))) {
            setIsCapsSupervisor(true);
          }

          if (login?.user?.roles.includes(encrypt('CAPS_OPERADOR'))) {
            setIsCapsOperador(true);
          }

          if (login?.user?.roles.includes(encrypt('CAPS_CONSULTA'))) {
            setIsCapsConsulta(true);
          }

          if (login?.user?.roles.includes(encrypt('CAPS_DOCS'))) {
            setIsCapsDocs(true);
          }

          if (login?.user?.roles.includes(encrypt('CAPS_DOCS_ESP'))) {
            setIsCapsDocsEsp(true);
          }

          if (login?.user?.roles.includes(encrypt('MDI'))) {
            setIsMdi(true);
          }

          if (login?.user?.roles.includes(encrypt('MDI_ADMIN'))) {
            setIsMdiAdmin(true);
          }

          if (login?.user?.roles.includes(encrypt('ERP'))) {
            setIsErp(true);
          }

          if (login?.user?.roles.includes(encrypt('PESQUISA'))) {
            setIsPesquisa(true);
          }

          if (login?.user?.roles.includes(encrypt('INSCRICAO_ADMIN'))) {
            setIsInscricaoAdmin(true);
          }
          
          if (login?.user?.roles.includes(encrypt('REDUCAO_DE_DANOS'))) {
            setIsReducaoDeDanos(true);
          }

          if (login?.user?.roles.includes(encrypt('RD_CONSULTA'))) {
            setIsReducaoConsulta(true);
          }
          
          if (login?.user?.roles.includes(encrypt('DOCS_DAS'))) {
            setIsDocsDas(true);
          }
          
          if (login?.user?.roles.includes(encrypt('DOCS_DITI'))) {
            setIsDocsDiti(true);
          }
          
          if (login?.user?.roles.includes(encrypt('DOCS_DTEC'))) {
            setIsDocsDtec(true);
          }
          
          if (login?.user?.roles.includes(encrypt('DOCS_DAF'))) {
            setIsDocsDaf(true);
          }
          
          if (login?.user?.roles.includes(encrypt('DOCS_DG'))) {
            setIsDocsDg(true);
          }
          
          if (login?.user?.roles.includes(encrypt('LEITOS'))) {
            setIsLeitos(true);
          }

          if (login?.user?.roles.includes(encrypt('CECO_ADMIN'))) {
            setIsCecoAdmin(true);
          }

          if (login?.user?.roles.includes(encrypt('CECO_OPERADOR'))) {
            setIsCecoOperador(true);
          }

          if (login?.user?.roles.includes(encrypt('GESTOR'))) {
            setIsGestor(true);
          }

          if (login?.user?.roles?.includes(encrypt('ATIV_ADMIN'))) {
            setIsAtivAdmin(true);
          }

          if (login?.user?.roles?.includes(encrypt('ATIV_OPERADOR'))) {
            setIsAtivOperador(true);
          }
          
          if (login?.user?.roles?.includes(encrypt('ATIV_CONSULTA'))) {
            setIsAtivConsulta(true);
          }

          // history.push('/');
        } catch (error) {
          userLogout();
        } finally {
          setLoading(false);
        }
      } else {
        setLogin(false);
        setIsAdmin(false);
        setIsMonitor(false);
        setIsConsulta(false);
        setIsUser(false);
        setIsResp(false);
        setIsVR(false);
        setIsVest(false);
        setIsOuvidoria(false);
        setIsOuvidoriaConsulta(false);
        setIsCipa(false);
        setIsCapsAdmin(false);
        setIsCapsSupervisor(false);
        setIsCapsOperador(false);
        setIsCapsConsulta(false);
        setIsCapsDocs(false);
        setIsCapsDocsEsp(false);
        setIsMdi(false);
        setIsMdiAdmin(false);
        setIsErp(false);
        setIsPesquisa(false);
        setIsInscricaoAdmin(false);
        setIsReducaoDeDanos(false);
        setIsReducaoConsulta(false);
        setIsDocsDas(false);
        setIsDocsDiti(false);
        setIsDocsDtec(false);
        setIsDocsDaf(false);
        setIsDocsDg(false);
        setIsCecoAdmin(false);
        setIsCecoOperador(false);
        setIsGestor(false);
        setIsAtivAdmin(false);
        setIsAtivOperador(false);
        setIsAtivConsulta(false);
        setIsLeitos(false);
      }
    };

    autoLogin();
  }, [userLogout, history]);

  /* useEffect(() => {
    if (
      localStorage.getItem('theme') === 'dark' ||
      (!('theme' in localStorage) &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      document.querySelector('body').classList.add('dark');
      setTheme('dark');
    } else {
      document.querySelector('body').classList.remove('dark');
      setTheme('light');
    }
  }, []); */

  /* const toggleThemeMode = () => {
    if (!localStorage.getItem('theme') || localStorage.getItem('theme') === 'light') {
      localStorage.setItem('theme', 'dark');
      document.querySelector('body').classList.add('dark');

      setTheme('dark')
    } else {
      localStorage.setItem('theme', 'light');
      document.querySelector('body').classList.remove('dark');

      setTheme('light');
    }
  }; */

  return (
    <UserContext.Provider value={{ 
      userLogout, 
      data, 
      error, 
      loading, 
      login,
      authenticate,
      token,
      signUp,
      isAdmin,
      isMonitor,
      isConsulta,
      isUser,
      isResp,
      isVR,
      isVest,
      isOuvidoria,
      isOuvidoriaConsulta,
      isCipa,
      isCapsAdmin,
      isCapsSupervisor,
      isCapsOperador,
      isCapsConsulta,
      isCapsDocs,
      isCapsDocsEsp,
      isMdi,
      isMdiAdmin,
      isErp,
      isPesquisa,
      isInscricaoAdmin,
      isReducaoDeDanos,
      isReducaoConsulta,
      isDocsDas,
      isDocsDiti,
      isDocsDtec,
      isDocsDaf,
      isDocsDg,
      isCecoAdmin,
      isCecoOperador,
      isGestor,
      isAtivAdmin,
      isAtivOperador,
      isAtivConsulta,
      isLeitos,
      // theme,
      // toggleThemeMode,
    }}>
      {children}
    </UserContext.Provider>
  );
};
